<template>
    <product-details v-if="product" :product="product"></product-details>
    <div v-else class="product-loading">
        <div class="page-spinner-wrapper">
            <span class="spinner-circle"></span>
        </div>
    </div>
</template>

<script>
import productDetails from '@/components/common/product-details';

export default {
    name: 'Product',
    components: {
        productDetails,
    },
    props: {},
    data() {
        return {
            product: undefined,
        };
    },
    computed: {
        service() {
            return this.$store.state.service;
        },
        imgHost() {
            return `${process.env.BASE_URL}static/images/`;
        },
        storeBackground() {
            return `${this.imgHost}products/${this.service.service_name}/${this.service.service_name}_bg.png`;
        },
        productId() {
            return this.$route.params.productId;
        },
    },
    mounted() {
        this.getProduct();
    },
    methods: {
        getProduct() {
            this.$shopAPI.getItem(this.$i18n.locale, this.service.service_group_code, this.productId).then(
                (item) => {
                    this.product = item;
                    this.$store.commit('setProductCrumb', this.product.name);
                },
                () => {
                    this.$router.push({
                        name: 'error',
                    });
                }
            );
        },
    },
};
</script>

<style lang="less" scoped>
.product-loading {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 350px;
    .spinner-circle {
        border: 10px solid #999;
        border-top: 10px solid #40d0ba;
        height: 60px;
        width: 60px;
    }
}
</style>
